import styled from 'styled-components/macro';
import {
  BREAKPOINTS,
  COLORS,
  FLEX_CONTAINER,
  FONTS,
  FONT_FAMILY,
} from 'utils/styles';

export const CounterContainer = styled.div`
  width: 100%;
  height: 310px;
  padding-left: 28px;

  @media ${BREAKPOINTS.xl} {
    padding-left: 28px;
  }

  @media ${BREAKPOINTS.lg} {
    padding-left: 28px;
  }

  @media ${BREAKPOINTS.md} {
    padding-left: unset;
  }
`;

export const QuestionText = styled.label`
  color: ${COLORS.mainColor};
  ${FONTS.font20};
  ${FONT_FAMILY.FontMedium};
`;

export const Counter = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};
  width: 110px;
  height: 32px;
  margin-top: 30px;
`;

export const MinusCount = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  cursor: pointer;
`;
export const PlusCount = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  cursor: pointer;
`;

export const CountValue = styled.p`
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular}
`;
